import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'uploadsetting';
export default {
    get(tablename) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/get-setting/${tablename}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}